import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createDraftSlice } from './slices/draftSlice';
import { createUISlice } from './slices/uiSlice';
import type { SecuritySelectionStore } from './types';

export const useSecuritySelectionStore = create<SecuritySelectionStore>()(
  devtools(
    immer((...a) => ({
      ...createDraftSlice(...a),
      ...createUISlice(...a),
    })),
    { name: 'SecuritySelectionStore' },
  ),
);
